import API from "@/api/lib/api";

export const getAllBuffets = async (restaurant_id) => {
  try {
    const response = await API.get(
      `restaurant/${restaurant_id}/buffets`
    );
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleBuffet = async (id) => {
  try {
    const response = await API.get(`restaurant/buffets/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createBuffet = async (data) => {
  try {
    const response = await API.post(`restaurant/buffets`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateBuffet = async (id, data) => {
  try {
    const response = await API.put(`restaurant/buffets/${id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteBuffet = async (id) => {
  try {
    const response = await API.delete(`restaurant/buffets/${id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
